export const environment = {
  production: true,
  baseURL: 'https://www.sehyog.co.uk/services/',
  frontBaseURL: 'https://www.sehyog.co.uk/',
  // baseURL: 'https://staging.sehyog.co.uk/services/',
  // frontBaseURL: 'https://staging.sehyog.co.uk/',
  liveGoogleCaptcha: '6LfP6KcUAAAAAAUlIn5zohaCJBSYir2ZPhoRrXz3',
  vendorDashboardURL: 'https://onlineexam.sehyog.co.uk/CBT2393/UserLogin.aspx?ClientID=239300', // changing as per vendor asked on 10-08-24 https://onlinetestforum.com/ECAS/UserLogin.aspx
  openAiKey: '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',
  paypalClientId: 'AbNIm8VKz-EUvmYJ9655f1Qnu6hxMhxcmr4vyZu8swh-KBIWTP0zKaPNUnfIkvqkSiL8SohPXs8yKpPC',
  paypalCurrency: 'GBP',
};

